export interface UploadDropZoneProps {
    onClick: (event: any) => void;
    label: string;
    id: string;
    dataTestId: string;
    error?: boolean;
    acceptFiles: string[];
    maxSize: string;
    value?: { file: File } | any | null;
    type?: string;
    multiple?: boolean;
    fileRange?: number;
    disabled?: boolean;
    removeText?: string;
    manualError?: string;
    acceptMultiDot?: boolean;
    allowDuplication?: boolean;
    onBlur?: (event: any) => void;
  }
  
  export const useIntl: Record<string, string> = {
    "file.tryAgain": "Try Again",
    "file.cancelUpload": "Cancel Upload",
    "file.removeImage": "Remove {type}",
    "file.dragAndDrop": "Drag and drop files here",
    "file.acceptedFiles": "Accepted file types:",
    "error.fileSize": "File size exceeds the limit of {size}",
    "error.notSupportedFileTypes": "File type not supported",
    "resource.error.duplicate": "Duplicate file detected",
  };
  
  export const convertFileSizeToBytes = (size: number, unit: string): number => {
    const units: Record<string, number> = {
      B: 1,
      KB: 1024,
      MB: 1024 * 1024,
      GB: 1024 * 1024 * 1024,
    };
    return size * (units[unit.toUpperCase()] || 1);
  };
  
  // Styles (stubbed for demonstration)
  import { makeStyles } from "@mui/styles";
  
  const useStyles = makeStyles({
    uploadDropZone: {
      border: "2px dashed #ccc",
      borderRadius: "8px",
      padding: "16px",
      textAlign: "center",
      cursor: "pointer",
    },
    uploadedDropZone: {
      border: "2px solid #4caf50",
    },
    progressDiv: {
      marginTop: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    linearProgress: {
      width: "100%",
      height: "6px",
    },
    linearErrorProgress: {
      width: "100%",
      height: "6px",
      backgroundColor: "#f44336",
    },
    image: {
      width: "100%",
      height: "auto",
      display: "block",
      borderRadius: "8px",
    },
    textFileArea: {
      backgroundColor: "#f9f9f9",
      padding: "8px",
      borderRadius: "4px",
      fontFamily: "monospace",
    },
    fileInput: {
      display: "none",
    },
    errorMsg: {
      color: "#f44336",
      margin: "8px 0",
    },
    tryAgain: {
      color: "#2196f3",
      cursor: "pointer",
    },
    tryAgainIcon: {
      marginRight: "8px",
    },
    clearUpload: {
      color: "#f44336",
      cursor: "pointer",
    },
    clearIcon: {
      marginRight: "8px",
    },
    fullwidthButton: {
      width: "100%",
    },
    imageSrc: {
      backgroundSize: "cover",
      backgroundPosition: "center",
      width: "100%",
      height: "200px",
      borderRadius: "8px",
    },
    uploadAlert: {
      marginTop: "8px",
    },
    imageDisabled: {
      pointerEvents: "none",
      opacity: 0.5,
    },
    input : {
        
    }
  });
  
  export default useStyles;